<template>
    <main :class="$store.state.user.theme">
        <div class="bgImage">
        </div>
        <div id="wrap">

            <div class="inner-wrap" v-bind:class="{ active: isActive}" id="innerWrap">
                <sidebar @toggleSidebar="toggleSidebar"></sidebar>

                <div class="right-section">
                    <navbar @toggleSidebar="toggleSidebar"></navbar>
                    <router-view></router-view>
                </div>

                <navfooter></navfooter>
            </div>

            <button @click="scrollTop" class="back-to-top"
                v-bind:class="{close: scrollPosition < 200, open: scrollPosition > 200}">
                <i class="fa-solid fa-arrow-up"></i>
            </button>

        </div>
    </main>
</template>

<script>
    import Navbar from "@/components/layout/dashboard/navbar";
    import Sidebar from "@/components/layout/dashboard/sidebar";
    import Navfooter from "@/components/layout/dashboard/navfooter";



    export default {
        name: "dashboard",
        components: { Sidebar, Navbar, Navfooter },
        data() {
            return {
                // sidebarVisible: false,
                scrollPosition: null,
                isActive: false,
                //mobileisActive:false,
            }
        },
        mounted() {
            window.addEventListener('scroll', this.updateScroll);
            //this.default_Call();
           
        },
        methods: {
            toggleSidebar(force = null) {
                // if (force !== null) {
                //     this.sidebarVisible = force;
                // } else {
                //     this.sidebarVisible = !this.sidebarVisible;
                // }
                this.isActive = !this.isActive
            },

            updateScroll() {
                this.scrollPosition = window.scrollY
            },

            scrollTop() {
                //   window.scrollTo(0, this.top,);
                $('html, body').animate({ scrollTop: 0 }, 700);
            },
            // default_Call() {
            //     let body_div = document.getElementById("wrap");
            //     body_div.removeAttribute('class', 'SingleView');
            // },
            
        }


    }
</script>